"use client";

import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { Badge } from "@/components/ui/badge";
import { useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { EXCLUDED_INN_NAME } from "@/components/meds/excluded-inn";

export const Icd10Inn = ({
  inn: { slug, id, name },
  code,
}: {
  inn: MedInnOnlyNameVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);
  const isExcludedInn = name === EXCLUDED_INN_NAME;

  if (isExcludedInn) {
    return (
      <Badge variant={"brandSoft"} asChild>
        {name}
      </Badge>
    );
  }

  const link = createPath("meds.inn.show", {
    slug: slug,
    id: id,
  });

  return (
    <Badge variant={"brandSoft"} asChild>
      <Link
        href={link}
        onClick={() => {
          logEvent("icd10_internal_link_click", logView, {
            icd_code: code,
            resource_path: link,
            resource_type: "inn",
          });
        }}
      >
        {name}
      </Link>
    </Badge>
  );
};
